import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
import { sendVSATProductItems } from "../../services/product/product.service";
import Title from "../../components/title";
import styles from "./VSAT.module.css";

let unlisten;
const VSATProducts = ({ history }) => {
  const imgRef = useRef();
  const [loading, setIsLoading] = useState(false);
  const [aboutList, setAboutList] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [tabContent, setTabContent] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  let { search } = useLocation();

  const query = new URLSearchParams(search);
  const tabIndex = query.get("t");

  const closeModal = () => {
    setShowModal(false);
  };

  const fetchVsatItems = useCallback(() => {
    setIsLoading(true);
    sendVSATProductItems().then(({ data }) => {
      setIsLoading(false);
      setAboutList((data && data.data) || []);
      if (window.location.href.indexOf("?t=") >= 0) {
        const tIndex = parseInt(window.location.href.split("?t=")[1]);
        if (
          (
            (tIndex &&
              !isNaN(tIndex) &&
              tIndex >= 1 &&
              tIndex <= data &&
              data.data) ||
            []
          ).length
        ) {
          const replacedImageText = data.data[tIndex - 1].rich_description;
          setTabContent(replacedImageText);
          setActiveIndex(tIndex - 1);
        }
      }
      if (
        !tabIndex ||
        isNaN(tabIndex) ||
        tabIndex < 1 ||
        tabIndex > data.data.length
      ) {
        const replacedImageText = data.data.rich_description;
        setTabContent(replacedImageText);
      } else {
        const replacedImageText = data.data[tabIndex - 1].rich_description;
        setTabContent(replacedImageText);
        setActiveIndex(tabIndex - 1);
      }
    });
  }, [tabIndex]);

  useEffect(() => {
    setBreadCrumbItems([
      { title: "خانه", url: "/" },
      { title: "خانه VSAT", url: "/vsat" },
      { title: "محصولات، خدمات و راهکارها", url: "/vsat/products" },
    ]);
    fetchVsatItems();
  }, [fetchVsatItems]);

  const changeTab = (index) => {
    const replacedImageText = aboutList[index].rich_description;
    setTabContent(replacedImageText);
    history.push({
      pathname: "/vsat/products",
      search: "?t=" + (parseInt(index) + 1),
    });
  };
  return (
    <>
      <Title title={"محصولات، خدمات و راهکارها"} />
      {showModal ? (
        <>
          <div id={styles.modalBackdrop} onClick={closeModal}></div>
          <div id={styles.modalWrapper}>
            <div className={styles.modalClose} onClick={closeModal}>
              &#x2715;
            </div>
            <img
              src={""}
              id={styles.modalAboutSource}
              ref={imgRef}
              alt={aboutList[activeIndex].title}
            />
          </div>
        </>
      ) : null}
      <div className="clearfix"></div>
      <div className={"container"}>
        <BreadCrumb items={breadCrumbItems} />
        {aboutList &&
        aboutList[activeIndex] &&
        Array.isArray(aboutList[activeIndex].attachment_files) &&
        aboutList[activeIndex].attachment_files.length > 0 ? (
          <div className={styles.headingBox}>
            <img
              src={
                aboutList[activeIndex].attachment_files[0].server_relative_url
              }
              alt={aboutList[activeIndex].title}
            />
          </div>
        ) : null}
        <div className={`row ${styles.wrapper}`}>
          {loading && (
            <div className={styles.loading}>
              <img
                src={"../../../assets/image/loading.svg"}
                alt={"در حال بار گذاری"}
              />
            </div>
          )}
          <div className={"col-xs-12 col-md-9"}>
            {tabContent ? (
              <div
                id={styles.tabContent}
                dangerouslySetInnerHTML={{ __html: tabContent }}
              ></div>
            ) : (
              <></>
            )}
          </div>
          <div className={"col-xs-12 col-md-3"}>
            <h2 className={styles.sidebarAboutTitle}>
              محصولات، خدمات و راهکارها
            </h2>
            {aboutList && aboutList.length > 0 ? (
              <ul id={styles.aboutTabSide}>
                {aboutList.map((item, index) => (
                  <li
                    className={index === activeIndex ? styles.active : null}
                    onClick={() => changeTab(index)}
                    key={index + "-key-tab-box"}
                  >
                    {item.title}
                    <i className="fa fa-angle-left" />
                  </li>
                ))}
              </ul>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default VSATProducts;
